import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import cardPurchase01 from "@/assets/images/help/card-purchase-01.png";
import cardPurchase02 from "@/assets/images/help/card-purchase-02.png";
import cardPurchase03 from "@/assets/images/help/card-purchase-03.png";
import cardPurchase04 from "@/assets/images/help/card-purchase-04.png";

export default function HelpCardPurchase() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-6">
          <h1 className="text-2xl font-bold mb-2">
            How to Purchase a Fellas Card
          </h1>
          <p className="text-sm text-muted-foreground">
            Follow the steps below to purchase your Fellas Card.
          </p>
        </div>

        {/* Content */}
        <div className="space-y-8">
          {/* Step 1 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">Step 1: Start the Purchase</h3>
            <p className="text-sm font-semibold">
              Go to PACKAGE → My Card and click the "Buy Now" button.
            </p>
            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src={cardPurchase01}
                alt="Step 1"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 2: Register the Card Recipient
            </h3>
            <p className="text-sm font-semibold whitespace-pre-line">
              To receive your card safely, please enter the information below
              accurately.
              {"\n\n"}
              Email Information
              {"\n"} · Email: Enter your email address.
              {"\n"} · Send Verification Code: Sends a verification code to the
              email you entered.
            </p>
            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src={cardPurchase02}
                alt="Step 2"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 continued */}
          <div className="space-y-4">
            <p className="text-sm font-semibold whitespace-pre-line">
              Card Recipient Information
              {"\n"} · First Name: Enter your first name.
              {"\n"} · Middle Name (Optional): Enter your middle name
              (optional).
              {"\n"} · Last Name: Enter your last name.
              {"\n"} · Select Nationality: Choose your nationality.
              {"\n"} · Phone Number: Enter your phone number in international
              format.
            </p>
            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src={cardPurchase03}
                alt="Step 2 continued"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 address */}
          <div className="space-y-4">
            <p className="text-sm font-semibold whitespace-pre-line">
              Billing / Residential Address
              {"\n"} · Select Country: Choose your country.
              {"\n"} · State / Province: Enter your state or province.
              {"\n"} · City: Enter your city.
              {"\n"} · Street Address: Enter your street address.
              {"\n"} · Apartment, Suite, Unit, etc. (Optional): Enter building,
              unit, or suite information (optional).
              {"\n"} · ZIP / Postal Code: Enter your postal code.
            </p>
            <div className="rounded-lg overflow-hidden shadow-md">
              <img
                src={cardPurchase04}
                alt="Address"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div className="mt-8 p-4 bg-primary/5 rounded-lg">
          <h3 className="text-lg font-bold opacity-90 mb-2">
            Step 3: Complete the Purchase
          </h3>
          <p className="text-sm font-semibold whitespace-pre-line">
            After verifying all the information, click the "Pay Now" button to
            complete your payment.
            {"\n\n"}
            Important Notes:
            {"\n"} · Make sure the card recipient information, billing address,
            email, and phone number are entered correctly.
            {"\n"} · Incorrect information may cause the card delivery or
            payment to fail.
            {"\n\n"}
            ⚠️ This product is non-refundable after purchase. Please make your
            decision carefully.
          </p>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/9")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: How to Register Your Card</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
